<template>
  <div class="commodity-lr-cont">
    <div class="commodity-item" @click="handleOpenPage()">
      <!-- <div
        class="commodity-item-l"
        v-show="goodsData.pic || goodsData.logo"
        :style="{
          'background': `url(${goodsData.pic || goodsData.logo}) no-repeat center center`,
          'background-size': 'cover'
        }">
        <img
          src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659926611681.png" alt=""
          class="seckill-icon"
          v-show="!isGroupGood">
      </div> -->
      <div class="commodity-item-l">
        <img :src="goodsData.pic || goodsData.logo" alt="" class="cover-img">
         <img
          src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659926611681.png" alt=""
          class="seckill-icon"
          v-show="!isGroupGood">
      </div>
      <div class="commodity-item-r">
        <div>
          <div class="commodity-item-title ellipsis">{{goodsData.name}}</div>
          <div class="commodity-tags-placehold">
            <span
              class="commodity-tags ellipsis"
              v-for="(item,index) in goodsData.labelNameList" :key="index"
              v-show="goodsData.labelNameList != null">
              {{item}}
            </span>
          </div>
        </div>
        <div class="commodity-price">
          <!-- 秒杀 -->
          <div class="seckill-salePrice" v-if="!isGroupGood">
            <div class="seckill-salePrice-box">
              <img src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659694341600.png" alt="">
              <span class="price">{{goodsData.seckillPrice}}</span>
            </div>
            <span class="original-price">原价:¥{{goodsData.originalPrice}}</span>
          </div>
          <!-- 团购 -->
          <div class="group-salePrice" v-if="isGroupGood">
            <div class="discount-price">
              <span class="price">￥{{goodsData.price}}</span>
              <img src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659694768467.png" alt="">
            </div>
            <span class="original-price">原价:¥{{goodsData.originalPrice}}</span>
          </div>
          <div class="apply-btn" :class="isGroupGood ? '': 'ani'">
            <span>{{isGroupGood ? goodsData.peopleNum+'人开团' : '去抢购'}}</span>
            <img src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659693171602.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'commodityLr',
  props: {
    goodsData: {
      type: Object,
      default: ()=>{}
    },
    isGroupGood: { // 是否是团购商品
      type: Boolean,
      default: true
    },
    index: {
      type: Number,
      default: 0
    },
  },
  filters: {
    filterStr(val) {
      let str = '';
      if (val) {
        if (val.length < 15) {
          str = val ? val : ''
        } else {
          str = val.substr(0,15) + '...'
        }
      }
      return str;
    }
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    handleOpenPage() {
      let data = {
        ...this.goodsData,
        index: this.index
      }
      this.$emit('detail',data)
    }
  }
}
</script>
<style lang="stylus" scoped>
  @import "../asset/css/commodityLr.styl"
</style>